var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28826 6.05926L6.98406 7.96636H6.02466L5.72046 6.05926V2.20996H7.28826V6.05926ZM7.19464 10.283C7.02304 10.4468 6.78904 10.5287 6.49264 10.5287C6.21184 10.5287 5.98564 10.4468 5.81404 10.283C5.64244 10.1192 5.55664 9.90076 5.55664 9.62776C5.55664 9.35476 5.64244 9.13831 5.81404 8.97841C5.98564 8.81851 6.21184 8.73856 6.49264 8.73856C6.78904 8.73856 7.02304 8.81851 7.19464 8.97841C7.36624 9.13831 7.45204 9.35476 7.45204 9.62776C7.45204 9.90076 7.36624 10.1192 7.19464 10.283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAlert);
export default __webpack_public_path__ + "static/media/ClearAlert.902a6c56.svg";
export { ForwardRef as ReactComponent };